import { useId, useState } from 'react'

import Icon from '@components/utils/Icon'
import cn from '@components/utils/cn'

import { scopedTranslation } from '@utils/I18n'

import { ChangeBreakdown, changeCount } from './ChangeBreakdown'

import type { ChangeBreakdownFields } from '../shifts/types'

const t = scopedTranslation('roster_board')

export function ChangeBreakdownAccordion({ breakdown }: { breakdown: ChangeBreakdownFields }) {
  const [open, setOpen] = useState(false)
  const bodyId = useId()
  const count = changeCount(breakdown)

  return (
    <div className="tw:rounded-lg tw:border tw:border-gray-200 tw:bg-white">
      <button
        type="button"
        onClick={() => setOpen((wasOpen) => !wasOpen)}
        aria-expanded={open}
        aria-controls={bodyId}
        className="tw:flex tw:w-full tw:items-center tw:justify-between tw:gap-2 tw:px-3 tw:py-2 tw:text-xs tw:font-semibold tw:text-gray-700 tw:focus:outline-hidden tw:focus-visible:ring-2 tw:focus-visible:ring-warning-400"
      >
        <span className="tw:inline-flex tw:items-center tw:gap-1.5">
          <Icon type="alert-circle" className="tw:h-4 tw:w-4 tw:text-warning-600" aria-hidden />
          {t('changes.count_to_publish', { count })}
        </span>
        <Icon
          type="chevron-down"
          className={cn('tw:h-4 tw:w-4 tw:text-gray-400 tw:transition-transform', open && 'tw:rotate-180')}
          aria-hidden
        />
      </button>
      {open && (
        <div id={bodyId} role="region" className="tw:border-t tw:border-gray-100 tw:px-3 tw:pb-3 tw:pt-1">
          <ChangeBreakdown breakdown={breakdown} showTitle={false} />
        </div>
      )}
    </div>
  )
}
